import {
  Box,
  Button,
  Circle,
  Heading,
  Img,
  SimpleGrid,
  Stack,
  Text,
  VisuallyHidden,
  useColorModeValue as mode,
  LightMode,
} from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import * as React from "react";
import { FaPlay, FaTwitter } from "react-icons/fa";
import { signIn, signOut, useSession } from "next-auth/react";
import { variant } from "theme/names";

const baseUrl =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:3003"
    : "https://app.tweethunter.io";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const item = {
  hidden: { position: "relative", opacity: 0, top: -5 },
  show: { position: "relative", opacity: 1, top: 0 },
};
const itemReversed = {
  hidden: { opacity: 0 },
  show: { opacity: 1 },
};

export const Hero = () => {
  return (
    <Box>
      <Box as="section" bg="gray.800" color="white" pt="7.5rem">
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
          paddingTop="20"
          height="calc(100vh - 193px)"
        >
          <Box textAlign="center">
            <motion.div
              variants={container as any}
              initial="hidden"
              animate="show"
            >
              <motion.div transition={{ duration: 0.6 }} variants={item as any}>
                <Heading
                  as="h1"
                  size="4xl"
                  fontWeight="extrabold"
                  maxW="48rem"
                  mx="auto"
                  lineHeight="1.2"
                  letterSpacing="tight"
                  bgGradient="linear(to-l, #f7ff00,#db36a4)"
                  bgClip="text"
                >
                  Get Twitter content ideas in seconds
                </Heading>
              </motion.div>
              <motion.div transition={{ duration: 0.6 }} variants={item as any}>
                <Text fontSize="2xl" mt="4" maxW="xl" mx="auto">
                  Best Twitter content exploration tool in the market. Forget
                  about 'What to post?' question.
                </Text>
              </motion.div>
              <motion.div
                transition={{ duration: 0.8 }}
                variants={itemReversed}
              >
                <Stack
                  justify="center"
                  direction={{ base: "column", md: "row" }}
                  mt="10"
                  mb="20"
                  spacing="4"
                >
                  <LightMode>
                    <Button
                      as="a"
                      href="#"
                      // size="lg"
                      // colorScheme="twitter"
                      variant={variant.Button.primary}
                      px="8"
                      // fontWeight="bold"
                      leftIcon={<FaTwitter />}
                      fontSize="md"
                      onClick={() =>
                        signIn("twitter", {
                          callbackUrl: baseUrl + "/dashboard",
                        })
                      }
                    >
                      Sign in with Twitter
                    </Button>
                  </LightMode>
                </Stack>
              </motion.div>
            </motion.div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
